import { token as tokenService, localUserId, currentProfile } from "../../store";
import { setCookie, deleteCookieByName } from "../../../utils/cookiesUtils";
import allProfiles from "../../store/allProfiles";
import userManager from "../user/user";

/**
 * Checks the response data object coming from signup request to see if there is token and user related
 * data included.
 * @param {Object} response - Response from signup request.
 * @returns {Boolean}
 */
export function canUpdateToken(response) {
  return !!response.data && !!response.data.token && !!response.data.user;
}

/**
 * Updates both JWT token and local globalUserId stored in SDK context (and also in cache in case of JWT token).
 * @param token
 * @param globalUserId
 * @param config
 */
export async function updateUserData(token, globalUserId, config = {}, profiles = [], spxToken = null) {
  const firstProfile = profiles && profiles.length > 0 && profiles[0];
  tokenService.updateToken.call(this, token);
  localUserId.update.call(this, globalUserId);
  if (spxToken) {
    firstProfile.token = spxToken;
    profiles[0].token = spxToken;
  }
  if (firstProfile) {
    allProfiles.update.call(this, profiles);
    currentProfile.update.call(this, { ...firstProfile, profileJwtToken: token });
    localStorage.setItem("locale", firstProfile.language);
  }

  await userManager.getAvatars.call(this);

  // above code is saving token and guid in indexdb. which is used by different services using getToken method.

  if (config.cookie) {
    const { name, expirationTime } = config.cookie;
    const jwtCookie = this.jwtCookie;
    setCookie(name || jwtCookie.name, token, expirationTime || jwtCookie.expirationTime);
  }
}

/**
 * Deletes both guesr JWT token and guest profile data from cookies.
 */
export function deleteGuestProfile() {
  deleteCookieByName("guest-jwt");
  deleteCookieByName("guest-profile");
  currentProfile.deleteProfile();
}
